import config from 'config';
import axios from 'axios';

const ROOT = config.API_BASE_URL;

class CompletedChecklistService {

  static get(completedChecklistId) {
    return new Promise((resolve, reject) => {
      axios.get(`${ROOT}checklists/${completedChecklistId}`).then((data) => {
        resolve({ checklist: data.data, response: data });
      }).catch((err) => {
        reject(err);
      });
    });
  }

  static getAll(options=[], minimal=false) {
    return new Promise((resolve, reject) => {
      let params = options.length == 0 ? '' : '?' + options.map(option => Object.keys(option).map((k, i) => `${k}=${option[k]}`)).join('&');
      axios.get(`${ROOT}checklists${params}&minimal=${minimal}`).then((data) => {
        resolve({ checklists: data.data.content, page: data.data, response: data });
      }).catch((err) => {
        reject(err);
      });
    });
  }

}

export default CompletedChecklistService;
